import React from 'react';
import Button from '../Button';
import Icon from '../Icon';
import Heading from '../Heading';
import { useStore } from '../../store';

interface IProps {
    title?: string;
    titleStyle?: string;
    assetPath?: string;
    navBarStyle: string;
    backButtonStyle?: string;
    backDestination?: number;
    navChildren?: React.ReactNode;
    handleNavigate?: () => void;
    backButtonId?: string;
}

const NavBar = ({
  title, titleStyle, backButtonStyle, navBarStyle, assetPath, backDestination, navChildren, handleNavigate, backButtonId,
}: IProps) => {
  const setCurrentPage = useStore(state => state.setCurrentPage);
  const handleClick = () => {
    if (backDestination !== undefined) {
      setCurrentPage(backDestination);
    }
  };

  return (
    <div className={`${navBarStyle}`}>
      <div className='flex items-center gap-[16px]'>
        {typeof backDestination === 'number'
        && (
        <Button
          id='NavBar'
          onClick={handleNavigate ?? handleClick}
          childElement={assetPath && <Icon iconId={backButtonId} src={assetPath} />}
          title=''
          className={backButtonStyle ?? ''}
        />
        ) }
        {title && <Heading title={title} className={titleStyle ?? ''} />}
      </div>
      {navChildren && navChildren}
    </div>
  );
};
export default NavBar;
